export default {
  width: 18,
  height: 18,
  stroke: true,
  svg: `
    <path d="M1 1H7V7H1V1Z" fill="none"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 11H7V17H1V11Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 1H17V7H11V1Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 11H17V17H11V11Z" fill="none"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  `
}
